import {styled} from '@linaria/react';
import React from 'react';
import {SectionWithLinks} from '../../../types/Entry';
import {LinkSection} from './LinkSection';
import {LinkHeader, TextHeader} from './SectionHeader';

interface LinkSectionsProps {
  columns?: number;
  className?: string;
  linkGroups: SectionWithLinks[];
  testId?: string;
}

export const LinkSections: React.FC<LinkSectionsProps> = ({
  linkGroups,
  className,
  testId,
}) => {
  return (
    <Sections data-testid={testId ?? 'links'} className={className}>
      {linkGroups.map(linkGroup => {
        return typeof linkGroup.title === 'string' ? (
          <React.Fragment key={linkGroup.title}>
            <TextHeader title={linkGroup.title} />
            <StyledLinkSection links={linkGroup.links} />
          </React.Fragment>
        ) : (
          <React.Fragment key={linkGroup.title.label}>
            <LinkHeader
              label={linkGroup.title.label}
              href={linkGroup.title.href}
            />
            <StyledLinkSection
              data-testid="section-links"
              links={linkGroup.links}
            />
          </React.Fragment>
        );
      })}
    </Sections>
  );
};

const Sections = styled.section`
  display: flex;
`;

const StyledLinkSection = styled(LinkSection)`
  margin-bottom: 1.5rem;
`;
